// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import DatePicker from "@insite/mobius/DatePicker/DatePicker";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { Checkbox, CheckboxGroup, Radio, RadioGroup } from "@insite/mobius/index";

import { generateDynamicGridItemStyle } from "@hardwoods/App/Widgets/DesignSystem/DesignSystem.utils";
import { dynamicDropdownOptions, longText } from "@hardwoods/App/Widgets/DesignSystem/DummyData";
import DynamicDropdown from "@insite/mobius/DynamicDropdown/DynamicDropdown";
import ListItem, { OrderedList, UnorderedList } from "@insite/mobius/Lists";
import Select from "@insite/mobius/Select";
import TextArea from "@insite/mobius/TextArea";
import TextField from "@insite/mobius/TextField";
import React, { useState } from "react";
import { css } from "styled-components";

export const XdlList = () => {
    return (
        <>
            <GridItem {...generateDynamicGridItemStyle(2, 2)}>
                <UnorderedList>
                    <ListItem>
                        Item 1
                        <UnorderedList>
                            <ListItem>Item 1.1</ListItem>
                            <ListItem>Item 1.2</ListItem>
                            <ListItem>Item 1.3</ListItem>
                        </UnorderedList>
                    </ListItem>
                    <ListItem>Item 2</ListItem>
                    <ListItem>Item 3</ListItem>
                    <ListItem>Item 4</ListItem>
                </UnorderedList>
            </GridItem>

            <GridItem {...generateDynamicGridItemStyle(2, 2)}>
                <OrderedList>
                    <ListItem>
                        Item 1
                        <OrderedList>
                            <ListItem>Item 1.1</ListItem>
                            <ListItem>Item 1.2</ListItem>
                            <ListItem>Item 1.3</ListItem>
                        </OrderedList>
                    </ListItem>
                    <ListItem>Item 2</ListItem>
                    <ListItem>Item 3</ListItem>
                    <ListItem>Item 4</ListItem>
                </OrderedList>
            </GridItem>
        </>
    );
};

export const XdlDatePicker = () => {
    return (
        <GridContainer>
            <GridItem {...generateDynamicGridItemStyle(3)}>
                <DatePicker label="Date" />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3)}>
                <DatePicker label="Date (required)" required />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3)}>
                <DatePicker label="Date (selected)" selectedDay={new Date(2019, 8, 12)} />
            </GridItem>
        </GridContainer>
    );
};

export const XdlCheckBox = () => {
    return (
        <CheckboxGroup label="Checkbox Group Label">
            <Checkbox checked>Checked</Checkbox>
            <Checkbox>Unchecked</Checkbox>
            <Checkbox checked disabled>
                Disabled Checked
            </Checkbox>
            <Checkbox checked="indeterminate" disabled>
                Disabled Indeterminate
            </Checkbox>
            <Checkbox disabled>Disabled</Checkbox>
        </CheckboxGroup>
    );
};

export const XdlRadio = () => {
    const [value, setValue] = useState("All");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };
    return (
        <RadioGroup value={value} onChangeHandler={logTargetValue}>
            <Radio key="All">All</Radio>
            <Radio key="Unread">Unread</Radio>
            <Radio key="Read">Read</Radio>
        </RadioGroup>
    );
};

export const XdlSelect = () => {
    const children = [
        <option key={1} value="">
            Select
        </option>,
        <option key={2} value={2}>
            apple
        </option>,
        <option key={3} value={3}>
            bananas
        </option>,
        <option key={4} value={4}>
            cherries
        </option>,
    ];
    const [value, setValue] = useState("");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };

    return (
        <>
            <StyledWrapper
                css={css`
                    width: 350px;
                    max-width: 350px;
                    margin-right: 100px;
                `}
            >
                <Select
                    label="Select the best one"
                    required
                    placeholder="Select"
                    value={value}
                    onChange={logTargetValue}
                >
                    {children}
                </Select>
            </StyledWrapper>

            <StyledWrapper
                css={css`
                    width: 120px;
                    max-width: 120px;
                `}
            >
                <Select
                    label="Paginition"
                    placeholder="Select"
                    value={value}
                    className="black-arrow"
                    onChange={logTargetValue}
                >
                    <option key={1} value={1}>
                        8
                    </option>

                    <option key={2} value={1}>
                        16
                    </option>

                    <option key={3} value={1}>
                        32
                    </option>
                </Select>
            </StyledWrapper>
        </>
    );
};

export const XdlDynamicDropdown = () => {
    const [value, setValue] = useState("");
    const handleSelectionChange = (value: any) => setValue(value);

    return (
        <StyledWrapper
            css={css`
                width: 350px;
                max-width: 350px;
            `}
        >
            <DynamicDropdown
                options={dynamicDropdownOptions}
                label="Dynamic Dropdown"
                selected={value}
                onSelectionChange={handleSelectionChange}
            />
        </StyledWrapper>
    );
};

export const XdlTextField = () => {
    const [value, setValue] = useState("");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };
    const infoIcon = <StyledWrapper></StyledWrapper>;
    return (
        <GridContainer>
            <GridItem {...generateDynamicGridItemStyle(3, 1)}>
                <TextField
                    value={value}
                    onChange={logTargetValue}
                    label="User Name"
                    data-test-selector="userName"
                    placeholder="Placeholder"
                />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3, 1)}>
                <TextField disabled={true} label="User Name" defaultValue="" data-test-selector="userName" />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3, 1)}>
                <TextField label="User Name" defaultValue="" error="Error" data-test-selector="userName" />
            </GridItem>
        </GridContainer>
    );
};

export const XdlTextArea = () => {
    const [value, setValue] = useState("");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };

    return (
        <GridContainer>
            <GridItem {...generateDynamicGridItemStyle(3, 1)}>
                <TextArea
                    onChange={logTargetValue}
                    defaultValue={value}
                    placeholder="Type some long content"
                    label="Description"
                />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3, 1)}>
                <TextArea label="TextArea" defaultValue={longText} />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3, 1)}>
                <TextArea disabled label="TextArea" defaultValue={longText} />
            </GridItem>
        </GridContainer>
    );
};
